import { take } from 'redux-saga/effects';
import i18n from 'i18next';
import languageSettings from '../../config/i18n';
import actionTypes from '../actionTypes';

export function* watchLanguageChanges() {
  while (true) {
    const action = yield take(actionTypes.LANGUAGE_CHANGE);
    const language = action.value;
    if (languageSettings.supportedLngs.indexOf(language) > -1) {
      i18n.changeLanguage(language);
    }
  }
}
